window.MIMO_CATALOG = {
  "currency": "CZK",
  "variants": [
    {
      "id": "57508218143095",
      "product": "bow",
      "name": "Mimo svítící motýlek",
      "option": "Růžová",
      "color": "#ef168a",
      "key": "pink",
      "image": "bow-pink-front.webp",
      "retail": 42600,
      "variant_ids": [
        "57508218143095"
      ],
      "selector": {
        "group": "bow",
        "groupLabel": "Barva",
        "label": "Růžová",
        "colors": [
          "#ef168a"
        ],
        "transparent": false,
        "order": 1
      }
    },
    {
      "id": "57508218175863",
      "product": "bow",
      "name": "Mimo svítící motýlek",
      "option": "Žlutá",
      "color": "#edda37",
      "key": "yellow",
      "image": "bow-yellow-front.webp",
      "retail": 42600,
      "variant_ids": [
        "57508218175863"
      ],
      "selector": {
        "group": "bow",
        "groupLabel": "Barva",
        "label": "Žlutá",
        "colors": [
          "#edda37"
        ],
        "transparent": false,
        "order": 2
      }
    },
    {
      "id": "57508218208631",
      "product": "bow",
      "name": "Mimo svítící motýlek",
      "option": "Zelená",
      "color": "#63d947",
      "key": "green",
      "image": "bow-green-front.webp",
      "retail": 42600,
      "variant_ids": [
        "57508218208631"
      ],
      "selector": {
        "group": "bow",
        "groupLabel": "Barva",
        "label": "Zelená",
        "colors": [
          "#63d947"
        ],
        "transparent": false,
        "order": 3
      }
    },
    {
      "id": "57508218241399",
      "product": "bow",
      "name": "Mimo svítící motýlek",
      "option": "Modrá",
      "color": "#3989ff",
      "key": "blue",
      "image": "bow-blue-front.webp",
      "retail": 42600,
      "variant_ids": [
        "57508218241399"
      ],
      "selector": {
        "group": "bow",
        "groupLabel": "Barva",
        "label": "Modrá",
        "colors": [
          "#3989ff"
        ],
        "transparent": false,
        "order": 4
      }
    },
    {
      "id": "57508218274167",
      "product": "bow",
      "name": "Mimo svítící motýlek",
      "option": "Bílá",
      "color": "#f7f7f2",
      "key": "white",
      "image": "bow-white-front.webp",
      "retail": 42600,
      "variant_ids": [
        "57508218274167"
      ],
      "selector": {
        "group": "bow",
        "groupLabel": "Barva",
        "label": "Bílá",
        "colors": [
          "#f7f7f2"
        ],
        "transparent": false,
        "order": 5
      }
    },
    {
      "id": "57508218306935",
      "product": "bow",
      "name": "Mimo svítící motýlek",
      "option": "Červená",
      "color": "#ed2c34",
      "key": "red",
      "image": "bow-red-front.webp",
      "retail": 42600,
      "variant_ids": [
        "57508218306935"
      ],
      "selector": {
        "group": "bow",
        "groupLabel": "Barva",
        "label": "Červená",
        "colors": [
          "#ed2c34"
        ],
        "transparent": false,
        "order": 6
      }
    },
    {
      "id": "57508218339703",
      "product": "bow",
      "name": "Mimo svítící motýlek",
      "option": "Oranžová",
      "color": "#ff9132",
      "key": "orange",
      "image": "bow-orange-front.webp",
      "retail": 42600,
      "variant_ids": [
        "57508218339703"
      ],
      "selector": {
        "group": "bow",
        "groupLabel": "Barva",
        "label": "Oranžová",
        "colors": [
          "#ff9132"
        ],
        "transparent": false,
        "order": 7
      }
    },
    {
      "id": "57508219093367",
      "product": "wireless",
      "name": "Mimo obrysové brýle",
      "option": "Fialová · černý rám",
      "image": "wireless-type10-studio.webp",
      "retail": 39900,
      "variant_ids": [
        "57508219093367"
      ],
      "selector": {
        "group": "black",
        "groupLabel": "Brýle s černým rámem",
        "label": "Fialová",
        "colors": [
          "#a84dff"
        ],
        "order": 0,
        "transparent": false
      }
    },
    {
      "id": "57508219191671",
      "product": "wireless",
      "name": "Mimo obrysové brýle",
      "option": "Bílá · čirý rám",
      "image": "wireless-type11-studio.webp",
      "retail": 39900,
      "variant_ids": [
        "57508219191671"
      ],
      "selector": {
        "group": "clear",
        "groupLabel": "Brýle s čirým rámem",
        "label": "Bílá",
        "colors": [
          "rgba(255,255,255,.55)"
        ],
        "order": 0,
        "transparent": true
      }
    },
    {
      "id": "57508219453815",
      "product": "wireless",
      "name": "Mimo obrysové brýle",
      "option": "Zelený obrys · modré stranice",
      "image": "wireless-type33-studio.webp",
      "retail": 39900,
      "variant_ids": [
        "57508219453815"
      ],
      "selector": {
        "group": "combined",
        "groupLabel": "Kombinované",
        "label": "Zelená + modrá",
        "colors": [
          "#63d947",
          "#3989ff"
        ],
        "order": 0,
        "transparent": false
      }
    },
    {
      "id": "57508219486583",
      "product": "wireless",
      "name": "Mimo obrysové brýle",
      "option": "Růžový obrys · modré stranice",
      "image": "wireless-type34-studio.webp",
      "retail": 39900,
      "variant_ids": [
        "57508219486583"
      ],
      "selector": {
        "group": "combined",
        "groupLabel": "Kombinované",
        "label": "Růžová + modrá",
        "colors": [
          "#ef168a",
          "#3989ff"
        ],
        "order": 1,
        "transparent": false
      }
    },
    {
      "id": "57508218962295",
      "product": "wireless",
      "name": "Mimo obrysové brýle",
      "option": "Růžová · černý rám",
      "image": "wireless-type3-studio.webp",
      "retail": 39900,
      "variant_ids": [
        "57508218962295"
      ],
      "selector": {
        "group": "black",
        "groupLabel": "Brýle s černým rámem",
        "label": "Růžová",
        "colors": [
          "#ef168a"
        ],
        "order": 1,
        "transparent": false
      }
    },
    {
      "id": "57508219060599",
      "product": "wireless",
      "name": "Mimo obrysové brýle",
      "option": "Ledově modrá · černý rám",
      "image": "wireless-type8-studio.webp",
      "retail": 39900,
      "variant_ids": [
        "57508219060599"
      ],
      "selector": {
        "group": "black",
        "groupLabel": "Brýle s černým rámem",
        "label": "Ledově modrá",
        "colors": [
          "#83e8ff"
        ],
        "order": 2,
        "transparent": false
      }
    },
    {
      "id": "57508219027831",
      "product": "wireless",
      "name": "Mimo obrysové brýle",
      "option": "Zelená · černý rám",
      "image": "wireless-type9-studio.webp",
      "retail": 39900,
      "variant_ids": [
        "57508219027831"
      ],
      "selector": {
        "group": "black",
        "groupLabel": "Brýle s černým rámem",
        "label": "Zelená",
        "colors": [
          "#63d947"
        ],
        "order": 3,
        "transparent": false
      }
    },
    {
      "id": "57508218667383",
      "product": "wireless",
      "name": "Mimo obrysové brýle",
      "option": "Žlutá · černý rám",
      "image": "wireless-type5-studio.webp",
      "retail": 39900,
      "variant_ids": [
        "57508218667383"
      ],
      "selector": {
        "group": "black",
        "groupLabel": "Brýle s černým rámem",
        "label": "Žlutá",
        "colors": [
          "#edda37"
        ],
        "order": 4,
        "transparent": false
      }
    },
    {
      "id": "57508218372471",
      "product": "glowing",
      "name": "Mimo brýle Linky",
      "option": "Růžová + ledově modrá",
      "image": "glowing-source.webp",
      "retail": 29900,
      "variant_ids": [
        "57508218372471"
      ]
    },
    {
      "id": "57508219519351",
      "product": "app",
      "name": "Mimo brýle s displejem",
      "option": "Programovatelný displej",
      "image": "app-studio.webp",
      "retail": 124900,
      "variant_ids": [
        "57508219519351"
      ]
    }
  ]
};
